/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_OcrInputs */

const en_pc_cmp_r_ocr = /** @type {(inputs: Pc_Cmp_R_OcrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR for scans`)
};

const zh_pc_cmp_r_ocr = /** @type {(inputs: Pc_Cmp_R_OcrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扫描件 OCR`)
};

/**
* | output |
* | --- |
* | "OCR for scans" |
*
* @param {Pc_Cmp_R_OcrInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_ocr = /** @type {((inputs?: Pc_Cmp_R_OcrInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_OcrInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_ocr(inputs)
	return zh_pc_cmp_r_ocr(inputs)
});
export { pc_cmp_r_ocr as "pc.cmp.r.ocr" }